module.exports = window["__MFE_SHARED__"]["@mui/material"];